import { resolveLibraryIcon as r } from "../libraries/index.js";
async function n(t) {
  return await fetch(t).then((e) => e.text()).catch(() => {
  });
}
async function o(t) {
  if (t.startsWith("http"))
    return await n(t);
  const e = r(t);
  if (e)
    return await n(e);
}
export {
  n as fetchAsset,
  o as resolveAndFetchIcon
};
